let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("dXgKT")).then(() => parcelRequire('9SXle'));